import { BaseConfig, BaseHttpClient, catchError } from '@jtnews/shared/newsapi/base';
import type { BasePageParams } from '@jtnews/shared/newsapi/params';

import { PersonalSelectionLazyBlockDTO } from './personal-selection.dto';

type FetchPersonalSelectionParams = BasePageParams & {
  commercialRecordFixedPlace: number;
  limit: number;
};

export class PersonalSelectionHttpClient extends BaseHttpClient {
  private readonly _personalSelectionNews =
    '/public/jtnews/services/blocks/personal_selection/';

  constructor(config: BaseConfig) {
    super(config);
  }

  @catchError
  public async fetchPersonalSelection({
    regionId,
    commercialRecordFixedPlace,
    limit
  }: FetchPersonalSelectionParams): Promise<PersonalSelectionLazyBlockDTO> {
    const url = `${this.getHost(regionId)}${this.v}${this._personalSelectionNews}`;

    const response = await this.httpClient.get<PersonalSelectionLazyBlockDTO>(url, {
      withCredentials: true,
      headers: {
        accept: this.accept
      },
      params: {
        regionId,
        commercialRecordFixedPlace,
        limit
      }
    });

    return response.data;
  }
}
